export default __webpack_public_path__ + "static/2010-3-b2ebee763cd695481344f9f965f706db.jpg";